import { Button, Container, Divider, Typography } from '@mui/material';
import React from 'react';
// import Programmer from "../../../../public/assets/svg/programmer.svg";
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import { useRouter } from 'next/router';
import { Box } from '@mui/system';

const NoData = (props) => {
  const router = useRouter()
  let prev_url = router && router.asPath ? router.asPath.substring(0, router.asPath.lastIndexOf('/')) : "/"

  if (props.noData) {
    return (
      // <div className={`no-data ${props.wrapperClass || ''}`}>{props.message || 'No Data available'}</div>
      <Container maxWidth="md" sx={{ textAlign: 'center', height: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }} className={`no-data ${props.wrapperClass || ''}`}>
        <Typography variant="h4" color="primary.main" sx={{ fontWeight: 600 }}>WE ARE WORKING ON THIS PAGE</Typography>
        {/* <Box sx={{ height: 'auto', maxWidth: '500px', mx: 'auto', mb: 2 }}>
            <Programmer />
          </Box> */}
        <Divider orientation="horizontal" variant="middle" sx={{ my: 3, width: '50%' }} />
        <Typography variant="body1" component="div" sx={{ color: 'text.very_light_desc' }}>
          {props.message || 'We are making lots of improvements and will be back soon.'}
        </Typography>
        <Box component="div" sx={{ mt: 10 }}>
          <Button size="small" href={prev_url} startIcon={<ArrowBackIosNewRoundedIcon sx={{ fontSize: '.9rem !important' }} />}>previous page</Button>
        </Box>
      </Container>)
  }
  return props.children
}

export default (NoData);
